import * as React from 'react';

import {
  CollapsibleBlock,
  CollapsibleBlockProps,
} from 'src/components/CollapsibleBlock';
import { FilterableItem } from 'src/components/FilterableCollapsibleBlock';
import {
  TableColumnChildren,
  TableItemRenderer,
} from 'src/containers/ProjectDiagram/components/resourceDrawer/TableItemRenderer';
import { TableWrapper } from 'src/containers/ProjectDiagram/components/resourceDrawer/TableWrapper';

export type CollapsibleTableProps<ItemType extends FilterableItem> = Omit<
  CollapsibleBlockProps,
  'children'
> & {
  children: TableColumnChildren<ItemType>;
  hasHiddenUntilHover?: boolean;
  items: ItemType[];
};

export const CollapsibleTable = <ItemType extends FilterableItem>({
  actions,
  children,
  className,
  hasHiddenUntilHover,
  header,
  items,
  testId,
}: CollapsibleTableProps<ItemType>) => {
  return (
    <CollapsibleBlock actions={actions} className={className} header={header}>
      <TableWrapper columns={children} testId={testId}>
        {items.map((item) => (
          <TableItemRenderer
            key={item.value}
            columns={children}
            hasHiddenUntilHover={hasHiddenUntilHover}
            item={item}
          />
        ))}
      </TableWrapper>
    </CollapsibleBlock>
  );
};
